import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import loadable from "@loadable/component"
import { Link } from "gatsby"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { officeSliderSettings } from "../SliderSettings/SliderSettings"
import "./assets/styles/_index.scss"
import { PageLinks } from "../../common/site/page-static-links";
const Slider = loadable(() => import("react-slick"))
const OfficeCard = loadable(() => import("../OfficeCard/OfficeCard"))
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")

const OfficeSlider = ({ pagedata }) => {
    const data = useStaticQuery(graphql`
        query {
            strapiGlobalModule(solutions_slider: {elemMatch: {publish: {eq: true}}}) {
                solutions_slider {
                  ...SolutionFragment
                }
            }
        }
    `);

    const solutionDet = data.strapiGlobalModule?.solutions_slider;
    return (
        <section className="office-slider-wrapper section-p104">
            <Container>
                <Row>
                    <Col lg={8} md={7}>
                        {pagedata?.module_intro && <ContentModule Content={pagedata.module_intro?.data?.module_intro} />}
                    </Col>
                    <Col lg={4} md={5} className="d-md-flex justify-content-end d-none">
                        <Link to={`/${PageLinks.solution}/`} className="button button-outline-white">View all solutions</Link>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Slider className="office-slider" {...officeSliderSettings}>
                            {
                                solutionDet?.map((item, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <OfficeCard officeCardDet={item} />
                                        </React.Fragment>
                                    )
                                })
                            }
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default OfficeSlider